import type { AnimalGroupDto } from "@strtmn/sds/types"
import { useContext } from "react"
import { FaCow } from "react-icons/fa6"
import { useParams } from "react-router-dom"
import config from "../../../config"
import { UserDataContext, UserDataContextHelper } from "../../../contexts"
import AnimalGroupItem from "../-components/AnimalGroupItem"
import { ListPage } from "../-components/ListPage"

import "../RecipeManagement.css"

export default function AnimalGroups() {
  const params = useParams()
  const { userData } = useContext(UserDataContext)
  const org = UserDataContextHelper.findOrg(params["orgId"]!, userData!)
  const animalGroups = UserDataContextHelper.findAnimalGroups(org)

  return (
    <>
      <ListPage
        _className="animal-groups"
        icon={<FaCow className="w-5 _h-3.5_ relativ text-[#3E9E29]" />}
        title="Ausladegruppen"
        items={animalGroups.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, {
            sensitivity: "base",
            numeric: true,
          })
        )}
        maxNumItems={config.limits.numberOfAnimalGroups}
        renderFunc={(item: AnimalGroupDto) => (
          <AnimalGroupItem key={item.id} org={org} item={item} hasEditButton />
        )}
      />

      {/* <small>* Die Icons "sliders-up", "eye (light)" benötigen FontAwesome Pro, kostet 49,- oder 99,- pro Jahr.</small> */}
    </>
  )
}
